export const LOCAL_DB_USERINFO_KEY = "userInfo";
export const LOCAL_DB_SALES_ORG_ID = "central-sales-org-id";
export const LOCAL_DB_TOKEN_KEY = "central-token";
export const LOCAL_DB_MENU_KEY = "central-menu";
export const IMAGETYPE =
  ".png,.jpg,.jpeg,.xbm,.tif,.svgz,.tiff,.gif,.svg,.pjpeg,.avif,.webp";
export const VIDEOTYPE = ".mp4,.mov,.rmvb,.rm,.flv,.avi,.wmv,.mkv";
/** 商户以后一次发货选择的物流公司key,保存在本地 */
export const LOCAL_DB_CENTRAL_USER_KEY = "central-web@user";

/** central平台用户权限点 sessionStorage key值 */
export const DB_LOCAL_USER_FUNCTIONS_KEY = "central-web@functions";

export const API_PRIFIX = "/vendor/service/v1";

export const USER_INFO_KEY = "central-user";

export const REMEMBER_ME_EXPIRE_TIME = 3 * 24 * 3600 * 1000;

export const fileTypes = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  bmp: "image/bmp",
  tif: "image/tiff",
  heic: "image/heic",
  txt: "text/plain",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: "text/csv",
  rtf: "application/rtf",
  html: "text/html",
  jfif: "image/jpeg",
  zip: "application/zip",
};

export const accept = Object.values(fileTypes)?.join(", ") || "";

export const File_LIMIT_SIZE = 5;

export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT_US = "MM/DD/YYYY";
export const DATETIME_FORMAT_US = "MM/DD/YYYY hh:mm";

export const TIMEOUT = 30000;
